import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'primereact/resources/themes/nova/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

class CBATableResults extends Component {

    constructor(props) {
        super(props);

        this.state = { data: null };
    }

    componentDidMount() {
        this.setState({
            data: JSON.parse(this.props.data)
        });
    }

    irrBodyTemplate(rowData) {
        return rowData.irr + " %";
    }

    render() {
        return (
            <div>
                <DataTable emptyMessage='Use the "Calculate" button to show results here.' value={this.state.data}>
                    <Column key='label' field='label' header='Name' />
                    <Column key='value' field='npv' header='NPV' />
                    <Column key='value' field='irr' header='IRR' body={this.irrBodyTemplate}/>
                    <Column key='value' field='bcratio' header='B/C Ratio' />
                </DataTable>
            </div>
        );
    }
}

export default CBATableResults;